module.exports = __webpack_public_path__ + "media/images/utees-biz-logo-035683a9aef1895e80d310fda61ab6ae.svg";